import { useContext } from "react";

import { DataRoomFolderBrowseFragmentFragment } from "@/src/graphql/generated";
import { DataRoomContext } from "..";
import { DataRoomTableRow } from "../table/row";
import { sortByIndex } from "@/src/utils/sortByIndex";

export function Files(props: {
  folder: DataRoomFolderBrowseFragmentFragment;
}) {
  const { filters, indexingEnabled } = useContext(DataRoomContext);

  const files = props.folder?.files.filter((file) => {
    if (filters.type && filters.type !== file.fileType) {
      return false;
    }

    if (filters.createdBy && file.createdBy.id !== filters.createdBy.id) {
      return false;
    }

    if (filters.lastUpdated && file.updatedAt < filters.lastUpdated) {
      return false;
    }

    return true;
  });

  return (
    <>
      {files
        .sort((a, b) => sortByIndex(a, b, indexingEnabled))
        .map((file, index) => {
          return (
            <DataRoomTableRow
              key={file.id}
              type="file"
              file={file}
              index={index}
            />
          );
        })}
    </>
  );
}
